import React, { useState, useRef, useEffect } from "react";
import { FaSortDown } from "react-icons/fa";
import "./SelectConFiltro.css";

const SelectConFiltro = ({
  label,
  options,
  selected,
  setSelected,
  placeholder = "Selecciona una opción",
}) => {
  const [filtro, setFiltro] = useState("");
  const [mostrar, setMostrar] = useState(false);
  const ref = useRef();

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setMostrar(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const opcionesFiltradas = options.filter((item) =>
    item.toLowerCase().includes(filtro.toLowerCase())
  );

  return (
    <div className="select-con-filtro" ref={ref}>
      {label && <label className="amc-label">{label}</label>}
      <div
        className="custom-select"
        onClick={() => setMostrar(!mostrar)}
      >
        <div
          className={`custom-select-selected ${
            !selected ? "placeholder-color" : ""
          }`}
        >
          {selected || placeholder}
        </div>
        <FaSortDown className="custom-select-icon" />
      </div>

      {mostrar && (
        <div className="custom-select-dropdown">
          <input
            type="text"
            className="custom-select-input"
            placeholder=""
            autoFocus
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
          <div className="custom-select-options">
            {opcionesFiltradas.length > 0 ? (
              opcionesFiltradas.map((op, idx) => (
                <div
                  key={idx}
                  className="custom-select-option"
                  onClick={() => {
                    setSelected(op);
                    setFiltro("");
                    setMostrar(false);
                  }}
                >
                  {op}
                </div>
              ))
            ) : (
              <div className="custom-select-option disabled">Sin resultados</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectConFiltro;
